import SCRIPT_TYPE from "enums/SCRIPT_TYPE";
import { STEPS } from "./VideoUpload/types/STEPS";

export const scope = "VideoManagement";

const DEFAULT_STEPPER_STATE = {
  activeStep: STEPS.SELECT_TYPE,
  questionOptions: [],
  scriptOptions: [],
  selectedTags: [],
  selectedParticipantIds: [],
  selectableIds: [],
  createdAfter: "",

  form: {
    type: SCRIPT_TYPE.MODERATED,
    scriptId: "",
    participantId: "",
    numberOfSpeakers: 1,
    videoName: "",
    questionId: "",
    firstName: "",
    lastName: "",
  },
};

const CreateVideoManagementStore = (set) => ({
  handleChange: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...currentState[scope], [key]: value },
      }),
      false,
      `${scope} : handleChange : ${key}`,
    );
  },

  openMobileOptionAndFilter: false,

  ...DEFAULT_STEPPER_STATE,

  handleFormChange: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: {
          ...currentState[scope],
          form: { ...currentState[scope].form, [key]: value },
        },
      }),
      false,
      `${scope} : handleFormChange`,
    );
  },
  handleFormReset: () => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: {
          ...currentState[scope],
          ...DEFAULT_STEPPER_STATE,
        },
      }),
      false,
      `${scope} : handleFormReset`,
    );
  },

  // Root onChange
  handleStoreChange: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...currentState[scope], [key]: value },
      }),
      false,
      `${scope} : handleStoreChange`,
    );
  },

  mutationsQueued: false,
  showAutoplayToggle: false,
  autoplay: false,
  autoplayTrigger: 0,
  currentVideo: null,
  textFilter: undefined,
  totalVideos: 0,
  showUnprocessedVideos: false,
  showDataResponses: false,
  showSkipped: false,
});

export default CreateVideoManagementStore;
